<template>
  <v-card flat class="mb-3 py-4 px-6 lsidebg" max-width="850">
    <v-card-title class="px-0 py-0 mb-2">
      <h6 class="text-h6 font-italic"> {{$t('search.boxtitle')}} </h6>
    </v-card-title>

    <!--adv search chips-->
    <v-row v-if="isAdvanced" no-gutters>
      <v-col cols="12" sm="8" lg="9" :class="$vuetify.breakpoint.smAndUp? 'pr-4': ''">
        <!--removed "close @click:close="item = false"", add function to drop a criteria here later-->
        <v-chip 
          v-for="(item, index) in advanced_search_queries" 
          :key="item"
          label 
          color="link lighten-5"
          class="mr-3 mb-2"
        >
          {{index}}: <span class="font-weight-bold ml-1"> {{item}} </span>
        </v-chip>
      </v-col>

      <!--search again button-->
      <v-col cols="12" sm="4" lg="3" >
        <v-row no-gutters :class="$vuetify.breakpoint.xsOnly?'pt-3':''">
          <v-spacer> </v-spacer>
          <v-btn 
            dense color="primary white--text"
            :block="$vuetify.breakpoint.xs"
            class="px-4"
            @click="$emit('revise_advanced_search')"
          > <v-icon small class="mr-4">mdi-text-search</v-icon>
            {{$t('btntxt.advagain')}}
          </v-btn>
        </v-row>
      </v-col>

    </v-row>

    <!--simple search bar-->
    <div v-else>
      <v-row no-gutters>
        <!--searched keywords-->
        <v-col cols="12" sm="9" >
          <v-textarea
            prepend-icon="search"
            v-model="sw"
            @keydown.enter.prevent="resubmit_simple(sw, disableSemSearch)"
            class="py-0 mb-0"
            :class="$vuetify.breakpoint.smOnly?'pr-5':''"
            hide-details dense clearable
            auto-grow rows="1"
            color="link"
          ></v-textarea>
        </v-col>

        <!--search button-->
        <v-col cols="12" sm="3">
          <v-row no-gutters :class="$vuetify.breakpoint.xsOnly?'pt-3':''">
            <v-spacer v-if="$vuetify.breakpoint.smAndUp"> </v-spacer>
            
            <v-btn 
              dense color="primary white--text"
              :block="$vuetify.breakpoint.xs"
              :disabled="searchWord===sw || sw===''"
              class="px-4"
              @click="resubmit_simple(sw)"
            >
              <v-icon small class="mr-4">mdi-magnify</v-icon>
              {{$t('btntxt.search')}}
            </v-btn>
          </v-row>
            
        </v-col>
      </v-row>

      <!--ITF D3 semantic search keyword recommendation when classified as concept-->
      <div v-if="!loadState && !isAdvanced && recommendedKW.length > 0">
        <h5 class="text-wdgt-subtitle mb-0 mt-3">
          {{$t('search.suggestion')}}
          <router-link to="/news#search_keyword" >
            <span class="beta-tag link--text ml-1" >{{$t('btntxt.newfeature')}}</span>
          </router-link>
        </h5>  
        <v-row no-gutters v-if="!loadState">
          <span class="ss-helptext mt-1 caption darkgrey--text" v-html="$t('search.suggestion_desc')"> </span>
        </v-row>
        <v-row no-gutters v-if="!loadState">
          <v-chip-group multiple column v-model="selectedKW">
            <v-chip 
              v-for="(item, index) in recommendedKW.slice(0,shownChips)" 
              :key="item.keyword" 
              label small filter :ripple="false" 
              color="link lighten-5"
              class="mr-2 mb-1 px-2 recommendation"
              active-class="sel-rec"
              @click="updateSelection(item.keyword, index)"
            >
              {{item.keyword}} 
            </v-chip>

            <v-btn 
              v-if="Object.keys(recommendedKW).length > 12" 
              @click="toogleShowChips" 
              small text
              class="my-1 px-2 d-print-none link--text show-hide"
            >
              <span v-if="showAllChips"> {{$t('btntxt.showless')}} <v-icon small class="ml-1">mdi-chevron-double-up</v-icon> </span>
              <span v-else> {{$t('btntxt.showall')}} <v-icon small class="ml-1">mdi-chevron-double-down</v-icon> </span>
            </v-btn>  
          </v-chip-group>
        </v-row>
      </div>

      <!--ITF D3 Show Fuzzy toogle when classified as entity -->
      <div v-if="!loadState && searchCat==='ENTITY'">
        <v-row no-gutters align="center" class="mt-1"> 
          <h5 class="text-wdgt-subtitle mb-0">
            {{$t('search.fuzzy')}}
              <router-link to="/news#search_entity" >
                <span class="beta-tag link--text px-2 mx-1"> {{$t('btntxt.newfeature')}} </span>
              </router-link>
          </h5>
          <v-switch
            v-model="toogleFuzzy"
            dense hide-details inset :ripple="false"
            class="mt-0 ml-4 pb-1"
            @change="updateFuzzy"
          >
            <template v-slot:label>
              <span class="text-body-2 darkgrey--text text--darken-1">{{ displayFuzzy? $t('search.fuzzy_on') : $t('search.fuzzy_off')}} </span>
              </template>
          </v-switch>
        </v-row>
        <v-row no-gutters align="baseline">
          <span class="ss-helptext caption darkgrey--text" v-html="$t('search.fuzzy_desc')"> </span>
        </v-row>
      </div>
      
    </div>
  </v-card>
</template>

<script>
  export default {
    name: 'SearchResubmit',
    props: {
      isAdvanced: {type: Boolean, default: false},
      advanced_search_queries: {type: Object, default: () => {}},
      searchWord: {type: String, default: ''}, //simple search search phrase
      searchCat: {type: String, default: ''},
      recommendedKW: {type: Array, default: () => {}},
      loadState: {type: Boolean},
      selected_keywords: {type: Array},
      disableSemSearch: {type: Boolean}, // for disabling fuzzy search
    },
    data(){
      return {
        sw: '',  // internal value of search word
        selectedKW: [], // index
        showAllChips: true,
        fuzzy: null,
      }
    },
    computed:{
      classification(){
        return this.$i18n.t('search.classification', [this.$i18n.t(`search.type.${this.searchCat.toLowerCase()}`)])
      },
      shownChips(){
        return this.showAllChips? this.recommendedKW.length : 6
      },
      displayFuzzy(){
        return !this.fuzzy 
      },
      toogleFuzzy:{
        get(){ return !this.fuzzy },
        set(value){ 
          this.fuzzy = !value 
          this.$emit('toggle_fuzzy',this.fuzzy)
        }
      }
    },
    watch: {
      searchWord(nv){
        this.sw = nv 
      },
      disableSemSearch(nv){
        this.fuzzy = nv
      },
    },
    methods: {
      resubmit_simple(sw, ss){
        this.selectedKW = [] 
        this.$emit('revise_searchword', sw, ss)
      },
      updateSelection(kw, idx){
        if( this.selectedKW.includes(idx) ){ //subtract
          this.sw = this.sw.replace( ("AND "+ kw) , "").replace(/\s+/g," ")
        }else{ //add
          this.sw = this.sw.trim() + " AND " + kw
        }
      },
      updateFuzzy(){
        this.fuzzy = !this.toogleFuzzy
        this.$emit('toggle_fuzzy',this.fuzzy)
      },
      toogleShowChips(){
        this.showAllChips =!this.showAllChips
      },
    },
  }
</script>

<style lang="scss" scoped>
  /*text input*/
  ::v-deep .v-textarea textarea{
    line-height: 1.3rem;
    height: 20px;
    min-height: 0px;
  }

  /*toogle buttons*/
  .show-hide{
    height: 24px !important;
    font-size: 0.7em;
  }

  ::v-deep .v-input--selection-controls__input {
    transform: scale(0.8);
    margin-right: 0px ;
    width: 42px;
  }

  /*recommendations*/
  ::v-deep .v-chip__content > .mdi:before{
    font-size: smaller;
    padding-left: 2px;
  }
  ::v-deep .v-chip__content {
    font-size: 1.1em;
  }
  .v-chip.recommendation{
    border: 1px solid var(--v-link-lighten5) !important;
  }
  .v-chip.common{
    border: 1px solid var(--v-l_case-base) !important;
  }
  .v-chip:hover{
    border: 1px solid var(--v-link-lighten1) !important;
  }
  .v-chip.sel-rec{
    border: 1px solid var(--v-link-base) !important;
    background-color: var(--v-link-lighten4) !important;
  }
  .v-chip--active::before, .v-chip:hover::before, .v-chip:focus::before {
    opacity: 0 !important;
  }
  .v-chip:hover *{
    cursor: pointer!important;
  }


  /*beta label*/
  .ss-helptext {
    line-height: 1rem;
  }
</style>

